import React from "react";
import { Box, Paper, Typography, Chip } from "@mui/material";
import { alpha } from "@mui/material/styles";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

// Grafické zobrazenie procesu ako tok krokov (karty so šípkami).
// Responzívne: horizontálne na šírke, vertikálne na mobile.
// props: title, subtitle, color ('primary'|'warning'|'error'|'success'|'info'),
//        Icon (hlavička), steps:[{Icon, title, desc}], note (voliteľný callout)
const ProcessFlow = ({ title, subtitle, color = "primary", Icon, steps = [], note }) => {
  return (
    <Paper
      elevation={0}
      sx={(theme) => ({
        p: { xs: 2, md: 3 },
        borderRadius: 3,
        border: "1px solid",
        borderColor: alpha(theme.palette[color].main, 0.35),
        bgcolor: alpha(theme.palette[color].main, 0.04),
      })}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
        {Icon && <Icon sx={{ color: `${color}.main` }} />}
        <Typography variant="h6" sx={{ fontWeight: 700, color: `${color}.main` }}>
          {title}
        </Typography>
      </Box>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {subtitle}
        </Typography>
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "stretch", md: "stretch" },
          gap: 1,
        }}
      >
        {steps.map((s, i) => (
          <React.Fragment key={i}>
            <Paper
              elevation={0}
              sx={(theme) => ({
                flex: 1,
                minWidth: 0,
                p: 1.75,
                borderRadius: 2.5,
                bgcolor: "background.paper",
                border: "1px solid",
                borderColor: "divider",
                display: "flex",
                flexDirection: "column",
                gap: 0.75,
              })}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box
                  sx={(theme) => ({
                    width: 32,
                    height: 32,
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: alpha(theme.palette[color].main, 0.12),
                    color: `${color}.main`,
                    flexShrink: 0,
                  })}
                >
                  {s.Icon ? <s.Icon fontSize="small" /> : <Typography variant="subtitle2">{i + 1}</Typography>}
                </Box>
                <Chip
                  size="small"
                  label={`Krok ${i + 1}`}
                  sx={{ height: 18, fontSize: 10, fontWeight: 700, bgcolor: alpha("#000", 0.04) }}
                />
              </Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 700, lineHeight: 1.25 }}>
                {s.title}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.45 }}>
                {s.desc}
              </Typography>
            </Paper>

            {i < steps.length - 1 && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: alpha("#888", 0.8),
                  transform: { xs: "rotate(90deg)", md: "none" },
                  py: { xs: 0.5, md: 0 },
                }}
              >
                <ArrowForwardIosRoundedIcon sx={{ fontSize: 16, color: `${color}.main`, opacity: 0.7 }} />
              </Box>
            )}
          </React.Fragment>
        ))}
      </Box>

      {note && (
        <Box
          sx={(theme) => ({
            mt: 2,
            p: 1.5,
            borderRadius: 2,
            bgcolor: alpha(theme.palette[color].main, 0.08),
            border: "1px dashed",
            borderColor: alpha(theme.palette[color].main, 0.4),
          })}
        >
          <Typography variant="body2" sx={{ color: "text.primary" }}>
            {note}
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default ProcessFlow;
